import { render } from "./EntranceFees.vue?vue&type=template&id=b1ecff6c"
import script from "./EntranceFees.vue?vue&type=script&lang=js"
export * from "./EntranceFees.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__